export default "__VITE_ASSET__C7libC$E__"